import { App } from 'vue'
import PrimeVue from 'primevue/config'

import MultiSelect from 'primevue/multiselect'
import CascadeSelect from 'primevue/cascadeselect'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import Tooltip from 'primevue/tooltip'
import Button from 'primevue/button'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import Dropdown from 'primevue/dropdown'
import SelectButton from 'primevue/selectbutton'
import ProgressBar from 'primevue/progressbar'
import Slider from 'primevue/slider'
import Chip from 'primevue/chip'
import ToastService from 'primevue/toastservice'
import Toast from 'primevue/toast'
import Password from 'primevue/password'

export const setupPrimeComponents = (app: App): void => {
  app.use(PrimeVue)
  app.use(ToastService)
  app.component('PToast', Toast)
  app.component('CascadeSelect', CascadeSelect)
  app.component('MultiSelect', MultiSelect)
  app.component('SimpleButton', Button)
  app.component('InputText', InputText)
  app.component('InputNumber', InputNumber)
  app.component('InputMask', InputMask)
  app.component('AccordionWrapper', Accordion)
  app.component('AccordionTab', AccordionTab)
  app.component('TabView', TabView)
  app.component('TabPanel', TabPanel)
  app.component('SimpleDropdown', Dropdown)
  app.component('SelectButton', SelectButton)
  app.component('ProgressBar', ProgressBar)
  app.component('ChipButton', Chip)
  app.component('PasswordInput', Password)
  app.component('SliderInput', Slider)

  app.directive('tooltip', Tooltip)
}
